(() => {
  const roots = document.querySelectorAll('[data-bb-referral-share]');

  if (!roots.length) return;

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  roots.forEach((root) => {
    const url = root.dataset.shareUrl || window.location.href;
    const title = root.dataset.shareTitle || document.title;
    const message = root.dataset.shareMessage || '';
    const fullMessage = `${message} ${url}`.trim();
    const status = root.querySelector('[data-bb-referral-status]');
    const shareButton = root.querySelector('[data-bb-referral-action="share"]');
    const copyButton = root.querySelector('[data-bb-referral-action="copy"]');
    const whatsAppLink = root.querySelector('[data-bb-referral-action="whatsapp"]');
    const emailLink = root.querySelector('[data-bb-referral-action="email"]');

    if (whatsAppLink) whatsAppLink.href = `https://wa.me/?text=${encodeURIComponent(fullMessage)}`;
    if (emailLink) {
      const subject = title || 'BuildingBasket';
      const isMobile =
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

      if (isMobile) {
        emailLink.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(fullMessage)}`;
      } else {
        emailLink.href = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(fullMessage)}`;
        emailLink.target = '_blank';
        emailLink.rel = 'noopener';
      }
    }

    const showCopied = async (value, confirmation) => {
      await copyText(value);
      if (status) status.textContent = confirmation;
    };

    copyButton?.addEventListener('click', () => {
      showCopied(fullMessage, 'Message copied').catch(() => {
        if (status) status.textContent = 'Please copy the referral message manually.';
      });
    });

    shareButton?.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title, text: message, url });
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }

      showCopied(url, 'Link copied').catch(() => {
        if (status) status.textContent = 'Please copy the page link from your browser.';
      });
    });
  });
})();
